import { render, staticRenderFns } from "./RecentTransactions.vue?vue&type=template&id=0b6eb965&"
import script from "./RecentTransactions.vue?vue&type=script&lang=js&"
export * from "./RecentTransactions.vue?vue&type=script&lang=js&"
import style0 from "./RecentTransactions.vue?vue&type=style&index=0&id=0b6eb965&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports